<template>
  <div class="login-wrap">
    <div class="w w1200 header_logo">
      <el-image class="logo" @click="$router.push('/')" :src="logo" fit="contain">
        <div slot="error" class="image-slot">
          <i class="el-icon-picture-outline"></i>
        </div>
      </el-image>
    </div>
    <div class="middle w w1200">
      <el-row>
        <el-col :span="12">
          <el-image class="login-banner" :src="require('../assets/img/loginBg.jpg')" fit="contain"></el-image>
        </el-col>
        <el-col :span="12">
          <div class="form-box">
            <div class="login-text">登 录</div>
            <el-form :model="ruleForm" status-icon :rules="rules" ref="ruleForm">
              <el-form-item prop="username">
                <el-input type="text" v-model="ruleForm.username" autocomplete="off" maxlength="11" placeholder="账号"></el-input>
              </el-form-item>
              <el-form-item prop="password">
                <el-input type="password" v-model="ruleForm.password" autocomplete="off" placeholder="密码"></el-input>
              </el-form-item>
              <el-form-item>
                <el-button class="btn-login" type="primary" block round :loading="loading" @click="submitForm('ruleForm')">登录</el-button>
              </el-form-item>
            </el-form>
            <div class="operation-box">
              <router-link tag="span" class="link" to="/retrievePassword">找回密码</router-link>
              <el-divider direction="vertical"></el-divider>
              <router-link tag="span" class="link" to="/register">立即注册</router-link>
            </div>
          </div>
        </el-col>
      </el-row>
    </div>
    <div class="footer_info" v-if="copyrights">
      <p>{{ copyrights.copyrightInformation }}</p>
      <p><a href="http://www.beian.miit.gov.cn/" target="_blank">{{ copyrights.icp }}</a></p>
    </div>
  </div>
</template>
<script type="text/ecmascript-6">
import {login, fetchImToken} from "../api/xunyou";
export default {
  name: 'login',
  data() {
    return {
      loading: false,
      ruleForm: {
        username: '',
        password: '',
        isNotCode: true,
      },
      rules: {
        username: [{required: true, message: '请输入账号', trigger: 'blur'}],
        password: [{required: true, message: '请输入密码', trigger: 'blur'}],
      }
    }
  },
  computed: {
    logo() {
      return this.$store.state.logo;
    },
    copyrights () {
      return this.$store.state.copyrights;
    }
  },
  methods: {
    //获取info列表
    submitForm() {
      this.$refs.ruleForm.validate(valid => {
        if (valid) {
          this.loading = true;
          login(this.ruleForm).then((res) => {
              this.loading = false;
              console.log('登录：', res);
              if (res.code === 0) {
                // 缓存用户个人信息
                this.$store.commit('login', res.data);
                this.$store.dispatch('getStoreData');
                this.getImToken();
                this.$router.replace({path: '/'});
              } else {
                this.$message.error(res.msg);
              }
            }).catch((err) => {
              console.log('错误：', err);
              this.loading = false;
              this.$message.error("登录失败，请稍后再试！");
            });
        }
      })
    },
    getImToken () {
      fetchImToken({ muid: this.$store.getters.userId })
      .then(res => {
        console.log('获取im通信token：', res);
        if (res.code === 0) {
          this.$store.commit('SAVE_IM_TOKEN', res.data);
          this.$store.dispatch('getUnreadCount');
        }
      })
      .catch(err => {
        console.error('错误：', err);
      })
    }
  }
}
</script>

<style scoped lang='less'>
.header_logo {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  font-size: 0;
  height: 80px;
  padding: 10px 0;
  .logo {
    height: 80px;
    max-height: 80px;
  }
}
.middle{
  background-color: #fff;
  border-radius: 10px;
  box-shadow: 0px 0px 15px rgba(238,238,238,0.4);
  font-size: 0;
  overflow: hidden;
  margin-top: 30px;
  .login-banner{
    width: 100%;
    height: auto;
  }
  .form-box{
    font-size: 14px;
    padding: 0 80px;
    box-sizing: border-box;
    /deep/ el-form-item{
      margin-bottom: 40px;
    }
  }
  .login-text{
    font-size: 2em;
    font-weight: bold;
    text-align: center;
    padding: 50px 0;
  }
  .btn-login{
    width: 100%;
    margin-top: 50px;
  }
  .operation-box{
    text-align: right;
    cursor: pointer;
    .link:hover{
      color: var(--main-theme-color);
      text-decoration: underline;
    }
  }
}
.footer_info {
  text-align: center;
  font-size: 12px;
  padding: 10px;
  color: #888888;
  margin-top: 20px;
  a{
    color: #888888;
  }
}

</style>



// WEBPACK FOOTER //
// src/views/login.vue